module.exports = __webpack_public_path__ + "static/media/comp-washing-s.5d68c1b6.jpg";